import React from "react";
import { RouteComponentProps } from "react-router";
import styled from "@emotion/styled/macro";

import { ICachedData } from "../ApiService";
import shelfGraphic from "../res/img_shelf_board_large.png";
import boxGraphic from "../res/img_box.png";
import { IEvent } from "../App";
import ApiService from "../ApiService";
import PlayFab from "../Playfab/PlayFab";
import MainIndex from "../index";

const Title = styled("h2")`
  text-align: center;
  color: #707381;
  font-size: 18px;
  letter-spacing: 0.6px;
  margin-bottom: 0.5em;
`;

const Subtitle = styled("h3")`
  font-size: 12px;
  color: #707381;
  text-align: center;
  text-transform: uppercase;
  margin: 0;
  letter-spacing: 3px;
  margin-bottom: 2em;
`;

const List = styled("ul")`
  padding: 60px 0 0;
  list-style: none;
  margin: 0;
  overflow-y: auto;
`;

const Shelf = styled("ul")`
  background: url(${shelfGraphic}) no-repeat center bottom transparent;
  background-size: contain;
  list-style: none;
  margin: 0;
  padding: 0 0 59%;
  display: flex;
  justify-content: center;
  &:empty {
    padding-top: 200px;
  }
`;

const BobbleItem = styled<"li", { collected: boolean; graphic: string }>("li")`
  width: 130px;
  height: 200px;
  margin: 0 20px -7px;
  background: ${({ collected }) =>
    collected
      ? "transparent"
      : `url(${boxGraphic}) no-repeat center bottom transparent`};
  background-size: contain;
  position: relative;

  &:after {
    content: "";
    display: block;
    position: absolute;
    width: 100%;
    height: 100%;
    background: url(${({ graphic }) => graphic}) no-repeat center bottom;
    background-size: contain;
  }
`;

interface IProps {
  collectedBobbleheadIds: string[];
  cachedData: ICachedData;
}

export default function MyCollection({
  collectedBobbleheadIds,
  cachedData,
  history
}: IProps & RouteComponentProps) {
  const events = Object.values(cachedData.events).filter(
    (event: IEvent) => event.bobbleheadIds.length > 0
  );
  if (events.length > 0) {
    if(MainIndex.GetBobbleID() === "M0") {
      return (
        <List>
            <li key={events[1].id}>
              <Title>{events[1].title}</Title>
              <Subtitle>{events[1].subtitle}</Subtitle>
              <Shelf>
                {events[1].bobbleheadIds
                  .map(bobbleheadId => cachedData.bobbleheads[bobbleheadId])
                  .filter(Boolean)
                  .map(bobblehead => {
                    const collected = collectedBobbleheadIds.includes(
                      bobblehead.id
                    );
                    return (
                      <BobbleItem
                        collected={collected}
                        key={bobblehead.id}
                        onClick={() => {
                          if (!collected) {
                            //console.log("not collected");
                            return;
                          }
                          //console.log("the bobblehead id is: " + bobblehead.id);
                          ApiService.setNewPrizeImage(PlayFab.GetPrizeString(bobblehead.id));
                          history.push(
                            `/collection/${bobblehead.id}${window.location.search}`
                          );
                        }}
                        graphic={
                          collected
                            ? bobblehead.thumbnailUrl
                            : bobblehead.silhouetteUrl
                        }
                      />
                    );
                  })}
              </Shelf>
            </li>
        </List>
      );
    } else {
      return (
        <List>
            <li key={events[0].id}>
              <Title>{events[0].title}</Title>
              <Subtitle>{events[0].subtitle}</Subtitle>
              <Shelf>
                {events[0].bobbleheadIds
                  .map(bobbleheadId => cachedData.bobbleheads[bobbleheadId])
                  .filter(Boolean)
                  .map(bobblehead => {
                    const collected = collectedBobbleheadIds.includes(
                      bobblehead.id
                    );
                    return (
                      <BobbleItem
                        collected={collected}
                        key={bobblehead.id}
                        onClick={() => {
                          if (!collected) {
                            //console.log("not collected");
                            return;
                          }
                          //console.log("the bobblehead id is: " + bobblehead.id);
                          ApiService.setNewPrizeImage(PlayFab.GetPrizeString(bobblehead.id));
                          history.push(
                            `/collection/${bobblehead.id}${window.location.search}`
                          );
                        }}
                        graphic={
                          collected
                            ? bobblehead.thumbnailUrl
                            : bobblehead.silhouetteUrl
                        }
                      />
                    );
                  })}
              </Shelf>
            </li>
        </List>
      );
    }
  }
  return (
    <List>
      <li>
        <Shelf />
      </li>
    </List>
  );
}
